class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 1000);

		if( this.querySelector('[data-mobile-facets-view-results-btn]')){
			this.querySelector('[data-mobile-facets-view-results-btn]').addEventListener('click',this.onSubmitHandler.bind(this));
		}else{
			this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
		}

		const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
		if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		}
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;

		const url = window.location.pathname + (searchParams ? '?' + searchParams : '');
		const gridContainer = document.getElementById('ProductGridContainer');
		const filtersContainer = document.getElementById('main-collection-filters');
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');

		if (gridContainer) gridContainer.classList.add('loading');
		if (countContainer) countContainer.classList.add('loading');
		if (countContainerDesktop) countContainerDesktop.classList.add('loading');

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

		fetch(url)
			.then(function(response) { return response.text(); })
			.then(function(html) {
				const doc = new DOMParser().parseFromString(html, 'text/html');

				const newGrid = doc.getElementById('ProductGridContainer');
				if (newGrid && gridContainer) {
					gridContainer.innerHTML = newGrid.innerHTML;
					gridContainer.classList.remove('loading');
				}

				const newCount = doc.getElementById('ProductCount');
				if (newCount && countContainer) {
					countContainer.innerHTML = newCount.innerHTML;
					countContainer.classList.remove('loading');
				}
				const newCountDesktop = doc.getElementById('ProductCountDesktop');
				if (newCountDesktop && countContainerDesktop) {
					countContainerDesktop.innerHTML = newCountDesktop.innerHTML;
					countContainerDesktop.classList.remove('loading');
				}

				const newFilters = doc.getElementById('main-collection-filters');
				if (newFilters && filtersContainer) {
					filtersContainer.innerHTML = newFilters.innerHTML;
					if (typeof initDesktopFacets === 'function') initDesktopFacets();
					if (typeof initMobileFacets === 'function') initMobileFacets();
				}

				const collectionSection = document.querySelector('[data-filter-wrapper]');
				if (collectionSection) {
					const top = collectionSection.getBoundingClientRect().top + window.pageYOffset;
					window.scrollTo({ top: top, behavior: 'smooth' });
				}
			})
			.catch(function() {
				window.location = url;
			});
	}

	static renderSectionFromFetch(url, event, searchParams) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	static renderSectionFromCache(filterDataUrl, event, searchParams) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
	}

	static renderProductGridContainer(html) {
	}

	static renderProductCount(html) {
		const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
		const container = document.getElementById('ProductCount');
		const containerDesktop = document.getElementById('ProductCountDesktop');
		container.innerHTML = count;
		container.classList.remove('loading');
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove('loading');
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements =
			parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest('.js-filter') : undefined;
			return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
		}
		const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

		var js_buttons = document.querySelectorAll('.js-button__slide-filter');
		for (let i = 0; i < js_buttons.length; i++) {
			if (js_buttons[i].getAttribute('listener') !== 'true') {
				js_buttons[i].addEventListener('click', () => {
					js_buttons[i].parentNode.toggleAttribute('open');
					js_buttons[i].setAttribute('listener', 'true');
				});
			}
		}
		document.querySelector('.custom-select-wrapper').addEventListener('click', function() {
			this.querySelector('.custom-select').classList.toggle('open');
		})
		for (const option of document.querySelectorAll(".custom-option")) {
			option.addEventListener('click', function(event) {
				if (!this.classList.contains('selected')) {
					this.parentNode.querySelector('.custom-option.selected').classList.remove('selected');
					this.classList.add('selected');
					this.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = this.textContent;

					const select = document.querySelector('.facet-filters__sort--steering');
					select.value = this.dataset.value;

					const d = document.querySelector('facet-filters-form')
					d.onSubmitHandler(event)
				}
			})
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
		})

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
		});

		document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector('.facets__selected');
		const sourceElement = source.querySelector('.facets__selected');

		if (sourceElement && targetElement) {
			target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			}
		]
	}

	onSubmitHandler(event) {
		event.preventDefault();
		let sort_form;
		let filter_form;

		if( event.target.closest('form').classList.contains('mobile-facets')){
			sort_form = document.querySelector('form.js-form__sorts.mobile-facets');
			filter_form = document.querySelector('form.js-form__filters.mobile-facets');
		}else{
			sort_form = document.querySelector('form.js-form__sorts.desktop-facets');
			filter_form = document.querySelector('form.js-form__filters.desktop-facets');
		}
		const formData_sorts = new FormData(sort_form);
		
		let formData_filters = ''
		
		if (filter_form !== null && filter_form.firstChild) {
			formData_filters = new FormData(filter_form);
		} else {
			formData_filters = '';
		}

		// orig
		// const searchParams = new URLSearchParams(formData).toString();

		// getting data from those forms
		let searchParams_sorts = new URLSearchParams(formData_sorts).toString();
		let searchParams_filters = new URLSearchParams(formData_filters).toString();

		// checking for params and joining them together depending if they are empty or not
		let searchParams = "";
		if (searchParams_sorts === "") {
			searchParams_sorts = 'sort_by=price-ascending';
		}
		if(searchParams_sorts !== "" && searchParams_filters !== "") {
			searchParams = `${searchParams_sorts}&${searchParams_filters}`
		} else if(searchParams_sorts !== "" && searchParams_filters === "") {
			searchParams = searchParams_sorts;
		} else if(searchParams_sorts === "" && searchParams_filters !== "") {
			searchParams = searchParams_filters;
		}
		// continuing normal operation
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		FacetFiltersForm.renderPage(url);
	}

	static fixShopify(searchParams) {
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input')
		    .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		this.querySelector('a').addEventListener('click', (event) => {
			event.preventDefault();
			const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
			form.onActiveFilterClick(event);
		});
	}
}

customElements.define('facet-remove', FacetRemove);
